export default "__VITE_ASSET__Cuc$jABl__"